export default "__VITE_ASSET__BfwATyQr__"